const SAAS_MENU = [
  { name: 'geo', title: 'Территориальная схема', number: '01',
    childs: [
      {name: 'geo.objects'}
    ]
  },
  { name: 'atu'},
  { name: 'garbage',
    childs: [
      {
        name: 'garbage.organizations'
      },
      {
        name: 'garbage.defenses'
      },
      {
        name: 'garbage.medics'
      },
      {
        name: 'garbage.managers'
      },
      {
        name: 'garbage.individualAreas'
      },
      {
        name: 'garbage.countryCommunitys'
      },
      {
        name: 'garbage.garages'
      },
      {
        name: 'garbage.settlements'
      }
    ]
  },
  { name: 'msn',
    childs: [
      {
        name: 'msn.withContainers'
      },
      {
        name: 'msn.withoutContainers'
      },
      {
        name: 'msn.separateCollections'
      }
    ]
  },
  { name: 'analytic'},
  {
    name: 'access',
    childs: [
      { name: 'access.users'},
      { name: 'access.usersGroups'},
      { name: 'access.journals'}
    ]
  }
]

export default SAAS_MENU
